const phoneMask = ({IMask}) => {
  const phoneInputElement = document.querySelector(`.js-phone-mask`);

  if (phoneInputElement) {
    const replaceNumber = (value, indexElement, newSubStr) => {
      if (value[indexElement] === `8`) {
        value = value.replace(`8`, newSubStr);
        phoneInputElement.value = value;
        phoneMask.updateValue();
      }
    };

    const phoneMask = IMask(document.querySelector(`.js-phone-mask`), {
      mask: "+{7}(000)000-00-00",
    });

    phoneInputElement.addEventListener(`input`, () => {
      let value = phoneInputElement.value;
      replaceNumber(value, 3, ``);
      phoneInputElement.dataset.phoneUnmask = phoneMask.unmaskedValue;
    });

    phoneInputElement.addEventListener(`paste`, (evt) => {
      let value = evt.clipboardData.getData(`text/plain`);
      replaceNumber(value, 0, `7`);
      phoneInputElement.dataset.phoneUnmask = phoneMask.unmaskedValue;
    });
  }
};

export default phoneMask;
